export const daysName = ['Dimanche','Lundi','Mardi','Mercredi','jeudi','Vendredi','Samedi']